import React, { ReactElement, useContext } from 'react';
import Link from 'atomic/link';
import Icon from 'atomic/icon';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { CategorySimple } from 'modules/shared/modules/categories-shared/interfaces/category-simple.interface';

import './category-list.scss';

interface CategoryListProps {
    isOpenMenu: boolean;
    onClose: () => void;
    departments: CategorySimple[];
}

const CategoryList: React.FC<CategoryListProps> = (props): ReactElement => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div
            className={`category-list ${props.isOpenMenu ? 'category-list--visible' : ''}
                category-list--${api.getDevice() === 'desktop' ? 'desktop' : 'mobile'}`}
        >
            <div className="category-list__wrapper">
                <div className="category-list__item">
                    {api.getDevice() === 'desktop'
                        ? (
                            <span className="category-list__close" tabIndex={0} role="button"
                                onClick={props.onClose}
                            >
                                <Icon name="x" aria-hidden="true" color="secondary"/>
                            </span>
                        )
                        : (
                            <div className="category-list__title">
                                Wszystkie kategorie:
                            </div>
                        )}
                    {props.departments.map(department => (
                        <Link
                            href={department.url}
                            key={department.name}
                            title={department.name}
                            className={api.getDevice() === 'desktop' ? 'desktop' : 'mobile'}
                        >
                            <Icon name={department.slug} size={22} color="secondary"/>
                            {department.name}
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CategoryList;
